import { Button, List, Radio } from "../../../../components";
import Localization from "../../../../localization";
import React, { useState } from "react";
import { Flex } from "antd";

const ManagePayment = ({
  options = [],
  onCancel = () => {},
  onSelect = () => {},
}) => {
  const [option, setOption] = useState(null);
  return (
    <>
      <List
        highlightOnHover={false}
        dataSource={options}
        renderItem={(item, index) => (
          <List.Item
            className="p-25-t p-25-b cursor-pointer"
            onClick={() => setOption(index)}
          >
            <List.Item.Meta
              avatar={<Radio checked={index === option} />}
              title={{ type: "secondary", children: item.title }}
            />
          </List.Item>
        )}
      />
      <Flex className="m-20-t" gap={"1rem"}>
        <Button
          type="primary"
          disabled={option === null}
          onClick={() => onSelect(option)}
          title={Localization.general.continue}
        />
        <Button title={Localization.general.cancel} onClick={onCancel} />
      </Flex>
    </>
  );
};

export default ManagePayment;
